module.exports = __webpack_public_path__ + "static/media/Zeus.b6f6f3f7.png";